// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "pre, code {\n  background-color: #ddd;\n}\n\ntd, th {\n  padding: 0 8px;\n}", "",{"version":3,"sources":["APost.css"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;;AAEA;EACE,cAAA;AACF","file":"APost.css","sourcesContent":["pre, code {\n  background-color: #ddd;\n}\n\ntd, th {\n  padding: 0 8px;\n}"]}]);
// Exports
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader/dist/cjs.js??ref--1-1!../node_modules/postcss-loader??ref--1-2!./components/APost/APost.css
// module id = 525
// module chunks = 37